import type { IIconProps } from '@app/components/Icon/types'
import { PldIcon } from '@tenable/paladin'
import type React from 'react'

interface IIconInfoTulProps extends IIconProps {}

const IconInfoTul: React.FC<IIconInfoTulProps> = props => {
  return (
    <tenable-floating-button
      id="help-menu-button"
      aria-haspopup="true"
      aria-label="Resource Center"
    >
      <PldIcon icon="IconHelp" size="iconSizeM" color="colorTextPrimary" />
    </tenable-floating-button>
  )
}

export default IconInfoTul
